<t
<template>
    <v-flex xl12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <h3>Novo banner</h3>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container fluid grid-list-lg>
                        <v-layout row wrap>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-text-field
                                        v-model="fields.title"
                                        :rules="nameRules"
                                        label="Nome do banner"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-text-field
                                        v-model="fields.link"
                                        label="Link do banner (Opcional)"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-select
                                        required
                                        v-model="fields.target"
                                        :items="[
                                           {target:'_self', text:'Na mesma página'},
                                           {target:'_blank', text:'Nova página'}
                                        ]"
                                        item-value="target"
                                        item-text="text"
                                        label="Comportamento"
                                ></v-select>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-btn btn dark flat @click.native="onUpload" :disabled="!valid"
                                       class="primary" style="margin: 0;">
                                    Selecionar arquivos
                                    <v-icon right dark>cloud_upload</v-icon>
                                </v-btn>
                                <p style="font-size: 10px">Arquivos suportados: JPEG, JPG, PNG. 1250x457 pixels</p>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12 v-if="select">
                                <h3> Prévia </h3>
                                <v-btn flat @click.prevent="deleteBanner" style="margin: 0;padding: 0" color="black">
                                    <v-icon color="red">delete</v-icon>
                                    Excluir
                                </v-btn>
                                <br/>
                                <img style="max-width: 700px;max-height: 300px;padding: 2px;border: 1px solid #cccccc;" :src="(!preview)? banner_default : preview">
                            </v-flex>
                            <input style="display: none" type="file" :multiple="true" ref="fileInput" :accept="'.jpg,.jpeg,.png'" @change="onFileChange">

                            <v-flex xl12 lg12 md12 sm12 xs12 v-if="loading">
                                <p>Enviando banner</p>
                                <div id="progress"></div>
                                <div id="progress-text"></div>
                            </v-flex>

                        </v-layout>
                    </v-container>
                    <v-flex xl12 lg12 md12 sm12 xs12 class="right">
                        <v-btn flat class="primary" @click="submit">Salvar</v-btn>
                        <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                    </v-flex>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    import Uploads from "../../components/Uploads";

    export default {
        name: 'banners-add',
        components: {Uploads},
        data: () => ({
            fields: {
                link: '',
                title: '',
                target: ''
            },
            valid: true,
            select: false,
            error: false,
            success: false,
            preview: '',
            banner: {},
            messages: '',
            banner_default: '',
            categories: [],
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ]
        }),
        methods: {
            deleteBanner: function () {
                this.banner = ''
                this.preview = ''
                this.select = false
            },
            onUpload() {
                if (!this.disabled) {
                    this.$refs.fileInput.click()
                }
            },
            onFileChange(e) {
                var self = this
                var files = e.target.files
                var ext = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
                if ((ext === 'jpeg') || (ext === 'jpg') || (ext === 'png')) {
                    self.banner = files[0]
                    this.createImage(self.banner)
                } else {
                    self.error = true
                    self.messages = 'Arquivo não suportado'
                }
            },
            createImage(file) {
                var self = this
                var reader = new FileReader()
                var vm = this
                reader.onload = (e) => {
                    vm.result = e.target.result
                    self.preview = vm.result
                    self.select = true
                }
                reader.readAsDataURL(file)
            },
            submit() {
                var self = this
                let form = new FormData()
                this.messages = ''
                if (this.$refs.form.validate()) {
                    form.append('title', this.fields.title)
                    form.append('target', this.fields.target)
                    form.append('link', this.fields.link)
                    if (self.banner.name) {
                        this.loading = true
                        form.append('banner', self.banner, self.banner.name)
                        this.axios.post('/add-banners.json', form, {
                            onUploadProgress: uploadEvent => {
                                this.valid = false
                                this.progress = Math.round((uploadEvent.loaded / uploadEvent.total * 100))
                                document.getElementById('progress').style.width = this.progress + '%'
                                document.getElementById('progress-text').innerText = 'Aguarde... ' + this.progress + '%, carregados '
                            },
                            headers: {
                                'Authorization': this.$store.state.token,
                                'content-type': 'multipart/form-data'
                            }
                        }).then(function (response) {
                            self.loading = false
                            if (response.data.success === true) {
                                self.messages = response.data.messages
                                self.success = true
                                setTimeout(function () {
                                    self.$router.push('/banners')
                                }, 2000)
                            } else {
                                self.error = true
                                self.messages = response.data.messages
                            }
                        })
                    } else {
                        self.messages = 'Selecione uma imagem para o banner!'
                        self.error = true
                    }
                }
            },
            clear() {
                this.$router.push('/banners')
            }
        }
    }
</script>
